export default{sources:{avif:"__VITE_ASSET__BFlkgqLz__ 400w",webp:"__VITE_ASSET__2Trxhfe4__ 400w"},img:{src:"__VITE_ASSET__bchVO03s__",w:400,h:267}};